import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() illustration?: string;
  @Input() title: string = '';
  @Input() description?: string;
  @Input() ctaLabel?: string;
  @Input() ctaRoute?: string | any[];
  @Input() ctaAction?: () => void;

  onCtaClick(): void {
    if (this.ctaAction) {
      this.ctaAction();
    }
  }
}